<template>
  <div>
    <vxe-grid
      ref="docTable"
      :data.sync="tableData"
      :columns="tableColumns"
      :height="333"
      auto-resize
      highlight-hover-row
      border
      size="mini"
      :edit-config="{ enabled: !disabled, trigger: 'click', mode: 'row' }"
    >
      <template v-slot:top>
        <div class="side-frame">
          <span class="side-frame-text">
            {{ $l('tc_expense_doc') || '费用相关文档' }}
          </span>
          <el-divider direction="vertical" v-if="!disabled"></el-divider>
          <b-button
            class="mr-2"
            size="sm"
            variant="outline-success"
            @click="UploadDocDialogVisible = true"
            v-if="!disabled"
            ><i class="el-icon-plus" /> {{ $l('INDEX.btn_upload') || '上传' }}
          </b-button>
          <b-button
            class="mr-2"
            size="sm"
            variant="outline-danger"
            v-if="!disabled"
            @click="batchDelDoc()"
            ><i class="el-icon-delete" />{{ $l('INDEX.btn_delete') || '删除' }}
          </b-button>
        </div>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_downloada') || '下载'"
            placement="top"
          >
            <i class="el-icon-download tool-btn" @click="downloadFile(row)"></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_delete') || '删除'"
            placement="top"
            v-if="!disabled"
          >
            <i class="el-icon-delete tool-btn" @click="delDoc(row)"></i>
          </el-tooltip>
        </div>
      </template>
    </vxe-grid>
    <UploadDocDialog
      ref="uploadDoc"
      :title="$l('dialog_title_upload_doc') || '上传费用相关文档'"
      :visible.sync="UploadDocDialogVisible"
      @upload="onDocUpload"
    />
  </div>
</template>
<script>
import tableColumns from './table-columns'
import UploadDocDialog from '../upload-doc'
export default {
  components: { UploadDocDialog },
  props: {
    disabled: { type: Boolean, default: false },
    tcExpenseCode: { type: String, default: '' },
  },
  data() {
    return {
      tableData: [],
      tableColumns: tableColumns(this),
      UploadDocDialogVisible: false,
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    loadData() {
      if (!this.tcExpenseCode) return
      this.$api
        .tcExpenseDocistApi({ tcExpenseCode: this.tcExpenseCode })
        .then((res) => {
          this.tableData = res.body.data
        })
    },
    getTableData() {
      const { fullData } = this.$refs.docTable.getTableData()
      return fullData
    },
    onDocUpload(e) {
      const { remark = '', listDoc } = e
      const data = listDoc.reduce((result, next) => {
        result.push({ ...next, remark })
        return result
      }, [])
      const tableData = this.getTableData()
      tableData.unshift(...data)
      this.tableData = [...tableData]
    },
    batchDelDoc() {
      this.$refs.docTable.removeCheckboxRow()
    },
    delDoc(row) {
      this.$refs.docTable.remove(row)
    },
    downloadFile({ fileCode = '' }) {
      this.$api.SYS_FILEDOWNLOAD(fileCode)
    },
  },
}
</script>
